import styled from 'styled-components';
import { getBaseTheme } from '@Themes';
import { layouts } from 'seal-ui-components';

export const ExpandablePanelWrapper = styled(layouts.VerticalBox)`
    background-color: ${getBaseTheme().colors.area.default.backgroundColor};
    > .BoxChild {
        margin-bottom: 0rem;
    }

    .separator__Button {
        right: ${getBaseTheme().spaces.default.default};
        bottom: -${getBaseTheme().spaces.default.s};
        height: ${getBaseTheme().sizes.l};
        width: ${getBaseTheme().sizes.l};
        position: absolute;
        background-color: ${getBaseTheme().colors.control.default.backgroundColor};
        border: 1px solid ${getBaseTheme().colors.area.default.strokeColor};
    }
`;

export const SystemPanelAddWrapper = styled.div`
    padding: 0rem ${getBaseTheme().spaces.insetSquish.s};
    display: ${props => (props.panelChecked === true ? 'block' : 'none')};
`;

export const TitleWrapper = styled.div`
    padding: ${getBaseTheme().spaces.insetSquish.s};
`;
